import { useEffect, useState } from "react";
import { Icon } from "@/components/ui/Icon";

interface MobileNavProps {
  sectionId: string;
  onSection: (id: string) => void;
  onBuy: () => void;
  onHelp: () => void;
}

const ITEMS = [
  { id: "studio",  icon: "wand",     label: "Studio"  },
  { id: "galeria", icon: "folder",   label: "Oferty"  },
  { id: "zdjecia", icon: "image",    label: "Galeria" },
  { id: "agencja", icon: "users",    label: "Agencja" },
  { id: "konto",   icon: "settings", label: "Konto"   },
];

export function MobileNav({ sectionId, onSection, onHelp }: MobileNavProps) {
  // iOS Safari: position:fixed bottom:0 jest liczone względem layout viewport (pełnego),
  // nie visual viewport — przy pokazanym pasku URL nav ląduje pod nim. Trackujemy
  // visualViewport, żeby trzymać nav na faktycznym dolnym brzegu widocznego obszaru.
  const [bottomOffset, setBottomOffset] = useState(0);

  useEffect(() => {
    const vv = window.visualViewport;
    if (!vv) return;
    const update = () => setBottomOffset(Math.max(0, window.innerHeight - vv.height - vv.offsetTop));
    update();
    vv.addEventListener("resize", update);
    vv.addEventListener("scroll", update);
    return () => {
      vv.removeEventListener("resize", update);
      vv.removeEventListener("scroll", update);
    };
  }, []);

  return (
    <nav className="mobile-nav" style={{ bottom: bottomOffset }}>
      {ITEMS.map((it) => (
        <button
          key={it.id}
          className={`mnav-item ${sectionId === it.id ? "is-active" : ""}`}
          onClick={() => onSection(it.id)}
        >
          <Icon name={it.icon} />
          <span>{it.label}</span>
        </button>
      ))}
      {/* Pomoc w dolnym navbarze (jak w V1) zamiast pływającego FAB zasłaniającego treść.
          Ikona dymka zamiast zdjęcia opiekuna — awatar w pasku ikon czytał się jak
          profil użytkownika, a nie jak „napisz do nas". */}
      <button className="mnav-item mnav-item--help" onClick={onHelp} aria-label="Pomoc">
        <Icon name="chat" />
        <span>Pomoc</span>
      </button>
    </nav>
  );
}
